import FreeDeliveryLottie from './assets/free-delivery.lottie';
import PersonalizedPlanLottie from './assets/personalized-plan.lottie';
import SupportLottie from './assets/support.lottie';

import DeliveryDefaultPng from './assets/free-delivery.png';
import PersonalizedPlanDefaultPng from './assets/personalized-plan.png';
import SupportDefaultPng from './assets/support.png';
import DeliveryDefaultWebp from './assets/free-delivery.webp';
import PersonalizedPlanDefaultWebp from './assets/personalized-plan.webp';
import SupportDefaultWebp from './assets/support.webp';

import UnderlineDrawing from './assets/underline.svg';

import styles from './BetterForThem.module.css';

export interface BetterForThemItem {
  id: number;
  animationPath: string;
  title: React.ReactNode;
  animationBuffer?: ArrayBuffer;
  defaultToImage: boolean;
  alt: string;
  src: string[];
}

export const betterForThemItems: BetterForThemItem[] = [
  {
    id: 1,
    animationPath: PersonalizedPlanLottie,
    title: (
      <>
        A personalized plan <br className={styles.mobileBreakline} />
        built <br className={styles.desktopBreakline} />
        for your dog
      </>
    ),
    alt: 'A personalized plan built for your dog',
    defaultToImage: false,
    src: [PersonalizedPlanDefaultWebp, PersonalizedPlanDefaultPng],
  },
  {
    id: 2,
    animationPath: FreeDeliveryLottie,
    title: (
      <>
        <span className={styles.underlineContainer}>
          Free delivery
          <UnderlineDrawing aria-hidden="true" className={styles.underline} />
        </span>{' '}
        on a schedule
        <br /> that works for you
      </>
    ),
    defaultToImage: false,
    alt: 'Free delivery on a schedule that works for you',
    src: [DeliveryDefaultWebp, DeliveryDefaultPng],
  },
  {
    id: 3,
    animationPath: SupportLottie,
    title: (
      <>
        Real people standing by
        <br />
        to support 24/7
      </>
    ),
    defaultToImage: false,
    alt: 'Real people standing by to support 24/7',
    src: [SupportDefaultWebp, SupportDefaultPng],
  },
];
